import {
  REVOKE_PATIENT_BY_AGENT_REQUEST,
  REVOKE_PATIENT_BY_AGENT_FAILURE,
  REVOKE_PATIENT_BY_AGENT_SUCCESS,
} from '../actions/actionTypes';

const initialState = {
  revokeUser: null,
  isFetchingRevokeUser: false,
  isErrorInRevokeUser: null,
};

const revokeByAgent = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case REVOKE_PATIENT_BY_AGENT_REQUEST:
        return {
          ...state,
          isFetchingRevokeUser: true,
          isErrorInRevokeUser: null,
        };
      case REVOKE_PATIENT_BY_AGENT_SUCCESS:
        return {
          ...state,
          isFetchingRevokeUser: false,
          revokeUser: action.payload,
          isErrorInRevokeUser: null,
        };
      case REVOKE_PATIENT_BY_AGENT_FAILURE:
        return {
          ...state,
          isFetchingRevokeUser: false,
          isErrorInRevokeUser: 'SomeThing went wrong.',
        };
      default:
        return state;
    }
  }
};

export default revokeByAgent;
